import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  linkTo?: string;
  linkLabel?: string;
  as?: "h2" | "h3";
}

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  linkTo,
  linkLabel = "查看全部",
  as = "h2",
}: SectionHeadingProps) {
  const Heading = as;
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between mb-6 md:mb-8">
      <div className="max-w-2xl">
        {eyebrow && (
          <div className="mb-2 flex items-center gap-2">
            <span className="h-3 w-3 rounded-sm bg-primary-500" aria-hidden="true" />
            <span className="font-label text-xs tracking-[0.2em] text-primary-700 uppercase">
              {eyebrow}
            </span>
          </div>
        )}
        <Heading className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-tight">
          {title}
        </Heading>
        {subtitle && (
          <p className="mt-2 text-sm md:text-base leading-relaxed text-foreground-600">
            {subtitle}
          </p>
        )}
      </div>
      {linkTo && (
        <Link
          to={linkTo}
          className="inline-flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 font-label text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
        >
          {linkLabel}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line text-sm" aria-hidden="true" />
          </span>
        </Link>
      )}
    </div>
  );
}